import ArrowStep from "./ArrowStep";

type StepDetails = {
    stepNumber: number;
    stepLabel: string;
};

type ArrowStepperProps = {
    steps: StepDetails[];
    currentStep: number;
};

const ArrowStepper = ({ steps, currentStep }: ArrowStepperProps) => {
    const buildSteps = () => {
        return steps.map(({ stepNumber, stepLabel }) => (
            <ArrowStep
                stepNumber={stepNumber}
                stepLabel={stepLabel}
                currentStep={currentStep}
            />
        ));
    };

    return (
        <div className="grid grid-cols-3 items-center ml-4">{buildSteps()}</div>
    );
};

export default ArrowStepper;
